import React, { useEffect, useState } from "react";
import EditStep1 from "./TenderUpdateForm/EditStep1";
import EditStep2 from "./TenderUpdateForm/EditStep2";
import EditStep3 from "./TenderUpdateForm/EditStep3";
import EditStep4 from "./TenderUpdateForm/EditStep4";
import EditStep5 from "./TenderUpdateForm/EditStep5";
import EditStep6 from "./TenderUpdateForm/EditStep6";
import EditWorkItemsDetails from "./TenderUpdateForm/EditWorkItemDetails";
import EditPreviewTender from "./TenderUpdateForm/EditPreviewTender";
import EditSelectApprovers from "./TenderUpdateForm/EditSelectApprovers";
import { useParams } from "react-router-dom";
import axios from "axios";

const EditTender = () => {
  const [tender, setTender] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const [step, setStep] = useState(1);
  const { tenderId } = useParams();
  const [workItems, setWorkItems] = useState([
    {
      itemName: "",
      description: "",
      section: "",
      unit: "",
      quantity: "",
      rate: "",
      total: 0,
    },
    {
      itemName: "",
      description: "",
      section: "",
      unit: "",
      quantity: "",
      rate: "",
      total: 0,
    },
    {
      itemName: "",
      description: "",
      section: "",
      unit: "",
      quantity: "",
      rate: "",
      total: 0,
    },
    {
      itemName: "",
      description: "",
      section: "",
      unit: "",
      quantity: "",
      rate: "",
      total: 0,
    },
    {
      itemName: "",
      description: "",
      section: "",
      unit: "",
      quantity: "",
      rate: "",
      total: 0,
    },
  ]);
  const [approvers, setApprovers] = useState({
    purchaseHead: "",
    technicalHead: "",
    financeHead: "",
  });
  const [noOfOpeners, setNoOfOpeners] = useState();
  const [openers, setOpeners] = useState([]);
  const [awardees, setAwardees] = useState({
    awardee1: "",
    awardee2: "",
  });

  const [filename, setFilename] = useState({
    ts1: "",
    ts2: "",
    ts3: "",
    ts4: "",
    ts5: "",
    ts6: "",
    ts7: "",
    ts8: "",
  });
  const [fileNames, setFileNames] = useState({
    tnc: "",
    serviceAgreement: "",
    protection: "",
  });

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        setTender(res.data);
        setFilename({...filename,
          ts1: res.data.ts1Filename,
          ts2: res.data.ts2Filename || "",
          ts3: res.data.ts3Filename || "",
          ts4: res.data.ts4Filename || "",
          ts5: res.data.ts5Filename || "",
          ts6: res.data.ts6Filename || "",
          ts7: res.data.ts7Filename || "",
          ts8: res.data.ts8Filename || "",
        })
        setFileNames({...fileNames,
          tnc: res.data.tncFilename || "",
          serviceAgreement: res.data.serviceAgreementFilename || "",
          protection: res.data.protectionFilename || "",
        })
      } catch (error) {
        console.log(error);
      }
    };

    getTender();
  }, []);
  return (
    <div>
      {step === 1 && (
        <EditStep1
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
        />
      )}
      {step === 2 && (
        <EditStep2
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
          fileNames={fileNames}
          setFileNames={setFileNames}
        />
      )}
      {step === 3 && (
        <EditStep3
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
        />
      )}
      {step === 4 && (
        <EditStep4
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
        />
      )}
      {step === 5 && !tender.isSingleBid && (
        <EditStep5
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
          filename={filename}
          setFilename={setFilename}
        />
      )}
      {step === 6 && (
        <EditStep6
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
          fileNames={fileNames}
          setFileNames={setFileNames}
        />
      )}
      {step === 7 && (
        <EditWorkItemsDetails
          tender={tender}
          data={workItems}
          setData={setWorkItems}
          setStep={setStep}
          user={user}
        />
      )}
      {step === 8 && (
        <EditSelectApprovers
          draft={tender}
          workItems={workItems}
          setStep={setStep}
          user={user}
          approvers={approvers}
          setApprovers={setApprovers}
          noOfOpeners={noOfOpeners}
          setNoOfOpeners={setNoOfOpeners}
          openers={openers}
          setOpeners={setOpeners}
          awardees={awardees}
          setAwardees={setAwardees}
        />
      )}
      {step === 9 && (
        <EditPreviewTender
          draft={tender}
          workItems={workItems}
          setStep={setStep}
          user={user}
          approvers={approvers}
          noOfOpeners={noOfOpeners}
          openers={openers}
          awardees={awardees}
          filename={filename}
          fileNames={fileNames}
        />
      )}
      
    </div>
  );
};

export default EditTender;
